import { DataProvider } from "@shared/constants/common";
import UserBasedTicketBasketRepository from "../../../../app-contexts/user/features/basket/data/repositories/UserBasedTicketBasketRepository/UserBasedTicketBasketRepository";
import VenueBasedTicketBasketRepository from "../../../../app-contexts/dashboard/features/box-office/basket/data/repositories/VenueBasedTicketBasketRepository";

class BasketRepositoryFactory {
  static getRepository(basketType: DataProvider, venueId: number | undefined) {
    let repository;
    switch (basketType) {
      case DataProvider.Venue:
        repository = new VenueBasedTicketBasketRepository({ venueId });
        break;
      // We use the user-based endpoint for both when a user is anonymous (public) or when a user is authenticated (user)
      case DataProvider.Public:
      case DataProvider.User:
        repository = new UserBasedTicketBasketRepository();
        break;
      default:
        return undefined;
    }

    return repository;
  }
}

export default BasketRepositoryFactory;
